import { useSPIntl } from 'hooks/useIntl';
import type { IntlKey } from 'locales';
import type { ReactNode } from 'react';
import { Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import type { ColorLevel } from 'types/sgBootstrap';

interface ScheduleProcessDoneModalProps {
  icon: string;
  title: IntlKey | ReactNode;
  summary?: IntlKey | ReactNode;

  leftBtn?: IntlKey | ReactNode;
  rightBtn?: IntlKey | ReactNode;
  content?: IntlKey | ReactNode;

  color: ColorLevel;

  onClosed: () => void;
  onRightClicked: () => void;
  onLeftClicked: () => void;
}
export function ScheduleStatusModal({
  content,
  rightBtn,
  leftBtn = 'done',
  title,
  summary,
  icon,
  onRightClicked,
  onLeftClicked,
  onClosed,
  color,
}: ScheduleProcessDoneModalProps) {
  const { idExists } = useSPIntl();
  return (
    <Modal show onHide={onClosed} contentClassName="border border-success border-2">
      <div className="flex-grow modal-header flex-wrap">
        <div className="d-flex flex-grow-1 justify-content-between">
          <div
            className={`rounded-circle bg-${color} bg-opacity-10 d-flex align-items-center justify-content-center mb-4`}
            style={{ width: '3rem', height: '3rem' }}
          >
            <em className={`icon icon-md text-${color} line-height-1`}>{icon}</em>
          </div>
          <button type="button" onClick={onClosed} className="btn btn-icon text-secondary">
            <i className="icon icon-md">close</i>
          </button>
        </div>

        <h3 className={`modal-title text-${color} mb-2 pt-0`}>
          {idExists(title) ? <FormattedMessage id={title} /> : title}
        </h3>
        {summary && (
          <p className="text-large text-secondary m-0">
            {idExists(summary) ? <FormattedMessage id={summary} /> : summary}
          </p>
        )}
      </div>
      <ModalBody className="overflow-visible  ">
        {idExists(content) ? <FormattedMessage id={content} /> : content}
      </ModalBody>
      <ModalFooter className="justify-content-end">
        <button
          className="btn btn-outline-secondary btn-outline btn-lg "
          data-e2e="left-button"
          onClick={onLeftClicked}
        >
          {idExists(leftBtn) ? <FormattedMessage id={leftBtn} /> : leftBtn}
        </button>
        <button onClick={onRightClicked} className={`btn btn-${color} btn-lg `} data-e2e="right-button">
          {idExists(rightBtn) ? <FormattedMessage id={rightBtn} /> : rightBtn}
        </button>
      </ModalFooter>
    </Modal>
  );
}
